<template>
  <modal id="importDataToSubdivisions" v-cloak>
    <div slot="title">
      <h3>Selecteer dochterbedrijven voor het overnemen van <b><u>alle data.</u></b></h3>
    </div>
    <div slot="body">
      <button class="btn-basic btn-outline-pulse-dark mr-2 mb-2" @click="unCheckAll">Alles<br>afvinken</button>
      <button class="btn-basic btn-outline-pulse mb-2" @click="checkAll">Alles<br>aanvinken</button>
      <div class="col-12 mt-2 text-left" style="padding-left: 150px">
        <div v-for="subdivision in subdivisions" :key="subdivision.id" class="checkbox-item">
          <input class="form-check-input" type="checkbox" :id="subdivision.id" v-model="subdivision.checked" />
          <label :for="subdivision.id">{{ subdivision.name }} ({{subdivision.abbreviation}})</label>
        </div>
      </div>
    </div>
    <div slot="footer" class="col-md-12 text-center">
      <button
          class="btn-basic btn-fill-pulse"
          @click="updateSubdivisions">
        Bevestigen
      </button>
    </div>
  </modal>
</template>
<script>

export default {
  props: ['subdivisions'],
  data: () => ({
    selectedSubdivisionsIds: []
  }),
  methods: {
    updateSubdivisions() {
      this.subdivisions.forEach(subdivision => {
        if (subdivision.checked === true) {
          this.selectedSubdivisionsIds.push(subdivision.id);
        }
      });
      this.$emit('subdivisions-to-update', this.selectedSubdivisionsIds);
      this.$emit('close');
    },
    checkAll() {
      this.subdivisions.forEach((subdivision, index) => {
        this.$set(this.subdivisions, index, { ...subdivision, checked: true });
      });
    },
    unCheckAll() {
      this.subdivisions.forEach((subdivision, index) => {
        this.$set(this.subdivisions, index, { ...subdivision, checked: false });
      });
    }
  }
};
</script>

<style scoped>
label {
  font-weight: bold;
}
</style>